/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LogsModule
 */

import { IApplicationLog } from 'generated-types';
import { Pipe, PipeTransform } from '@angular/core';

interface IResponseInfo extends Pick<IApplicationLog,
'response_content_type' | 'server_side_redirect_uri'> {
    serverResponseLength?: number;
    grpcStatus?: number;
}

/* eslint-disable @typescript-eslint/naming-convention */
/**
 * @description
 *     Pipe for extracting response info from an L7 log.
 * @author Zhiqian Liu
 */
@Pipe({
    name: 'responseInfo',
})
export class ResponseInfoPipe implements PipeTransform {
    /** @override */
    // eslint-disable-next-line class-methods-use-this
    public transform(log: IApplicationLog): IResponseInfo {
        if (!log) {
            return {};
        }

        const {
            server_response_length,
            response_content_type,
            server_side_redirect_uri,
            grpc_status,
        } = log;

        return {
            // returned result can be a string
            serverResponseLength: server_response_length !== undefined ?
                Number(server_response_length) : undefined,
            response_content_type,
            server_side_redirect_uri,
            grpcStatus: grpc_status === -1 ? undefined : grpc_status,
        };
    }
}
